import { ICourseModulesNodes } from '@dtos/Course'

// Tamanho das páginas pedidas ao core em getCourseModules. O core pagina os
// submódulos DEPOIS de filtrar por `available`, então uma página cheia
// (=== PAGE_SIZE) é o único sinal de que ainda pode haver mais.
export const SUBMODULES_PAGE_SIZE = 20
export const COURSE_CONTENTS_PAGE_SIZE = 10
export const MODULES_PAGE_SIZE = 5

interface IHasMoreSubmodulesParams {
  // Quantos submódulos já foram BUSCADOS para esse módulo (lista crua da
  // resposta), nunca a lista filtrada para exibição.
  fetchedCount: number
  // Módulos que já devolveram uma página incompleta/vazia.
  exhaustedModuleIds?: ReadonlySet<number>
  moduleId?: number
}

/**
 * Antes o gatilho de "carregar mais submódulos" era
 * `submodulosVisiveis.length % 20 === 0`, calculado sobre a lista JÁ FILTRADA
 * (submódulos sem conteúdo são escondidos). Bastava um submódulo escondido
 * dentro da página para o resto deixar de ser 0 e a paginação morrer: o módulo
 * "RESOLUÇÃO DE QUESTÕES DO ENARE" buscava 20, exibia 19 (o primeiro,
 * "Comece aqui", não tem conteúdo) e parava para sempre em 19 de 35.
 *
 * O tamanho da página vale para a lista buscada, então a decisão tem que sair
 * dela — e nunca da lista renderizada.
 */
export const hasMoreSubmodulesToFetch = ({
  fetchedCount,
  exhaustedModuleIds,
  moduleId,
}: IHasMoreSubmodulesParams): boolean => {
  if (moduleId !== undefined && exhaustedModuleIds?.has(moduleId)) return false
  if (fetchedCount <= 0) return false
  return fetchedCount % SUBMODULES_PAGE_SIZE === 0
}

// O predicado de fim de lista mora em `apolloErrors`, ao lado do de
// `unauthorized`: é a mesma decisão (código de erro do core) e hoje tem três
// paginações consumindo.
export { isEmptyPageError } from './apolloErrors'

export const hasMoreSubmodulesForModule = (
  module: Pick<ICourseModulesNodes, 'id' | 'courseModules'>,
  exhaustedModuleIds?: ReadonlySet<number>,
): boolean =>
  hasMoreSubmodulesToFetch({
    fetchedCount: module.courseModules?.length ?? 0,
    exhaustedModuleIds,
    moduleId: module.id,
  })
